module.exports = __webpack_public_path__ + "static/media/amulet_10.756b98b3.png";